import React, { useState, useEffect, useRef } from 'react';
import './customslider.css';
import HeaderText from '../helpers/HeaderText';
import Testimonial from '../helpers/Testimonial';
import testimonialData from '../../data/Testimonial.json'

const tiles = ['Tile 1', 'Tile 2', 'Tile 3', 'Tile 4', 'Tile 5'];

export default function Reviews(props) {
    const data = testimonialData
    const { limit }=props 

  return (
    <>
        <HeaderText text="What customers say" />
        <div className="loop-container">
            <div className="loop-track-left">
                {/* two copies for seamless infinite looping */}
                {[...data.slice(0, limit),...data.slice(0, limit)].map((tile, i) => (
                    <div className="loop-tile" key={i}>
                        <Testimonial data={tile} type='style-one'/>
                    </div>
                ))}
            </div>
        </div>
    </>
    
  );



}